module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-7-a79df7d4635ee64a149766f657b2e0bf.jpg";